<script lang="ts" setup>
interface Props {
  currPage: number
  totalPages: number
}

const props = defineProps<Props>()
const emit = defineEmits(['changePage'])
const route = useRoute()
const router = useRouter()
const pages = ref([])

pagination()
function pagination() {
  const total = props.totalPages
  const current = props.currPage

  if (total <= 7) {
    // When the total number of pages is small, show all
    for (let i = 1; i <= total; i++)
      pages.value.push(i)
  }
  else {
    // Always show first page
    pages.value.push(1)

    // Pages near the start
    if (current <= 3) {
      pages.value.push(2, 3, 4)
      pages.value.push('...')
    }
    // Pages near the end
    else if (current >= total - 2) {
      pages.value.push('...')
      pages.value.push(total - 3, total - 2, total - 1)
    }
    // Pages in the middle
    else {
      pages.value.push('...')
      pages.value.push(current - 1, current, current + 1)
      pages.value.push('...')
    }

    // Always show last page
    pages.value.push(total)
  }
}

function getPaginationUrl(page: number) {
  return `${route.path}?${new URLSearchParams({ ...route.query, page: page.toString() }).toString().replaceAll('?page=1', '').replaceAll('&page=1', '')}`
}

function goTo(event: any, page: number) {
  event.preventDefault()
  emit('changePage', page)
}
</script>

<template>
  <ul class="flex space-x-2">
    <li v-for="page in pages" :key="page">
      <a v-if="page !== '...'" :class="`${currPage === page ? 'bg-primary-500 border-primary-500 text-white' : 'border-gray-300 bg-white'} w-8.5 h-9 leading-8 text-center border rounded-md font-semibold block`" :href="getPaginationUrl(page)" @click="goTo($event, page)">{{ page }}</a>
      <span v-else class="border-gray-300 bg-white w-8.5 h-9 leading-8 text-center border rounded-md font-semibold block">{{ page }}</span>
    </li>
  </ul>
</template>
